<div class="buttons-container" [ngClass]="{show: show}">
    <a class="btn-item" (click)="onPin()">
        <fa-icon [icon]="pinIcon"></fa-icon>
    </a>
    <!-- <a class="btn-item" (click)="onMicMute()"><fa-icon [icon]="micMuteIcon"></fa-icon></a>
    <a class="btn-item" (click)="onCamOff()"><fa-icon [icon]="camMuteIcon" ></fa-icon></a>
    <a class="btn-item" (click)="onCick()"><fa-icon [icon]="kickIcon"></fa-icon></a> -->
</div>